import { motion } from "framer-motion";
import { Cpu, Smartphone, Palette } from "lucide-react";
import { useLang } from "@/lib/lang";

export default function AboutSection() {
  const { t } = useLang();
  const features = [
    { icon: Cpu, title: t("about_f1_title"), description: t("about_f1_desc") },
    { icon: Smartphone, title: t("about_f2_title"), description: t("about_f2_desc") },
    { icon: Palette, title: t("about_f3_title"), description: t("about_f3_desc") },
  ];

  return (
    <section id="about" data-testid="about-section" className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="mb-16">
          <p className="label-mono mb-4">{t("about_label")}</p>
          <h2 data-testid="about-heading" className="font-['Unbounded'] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white mb-6">{t("about_heading")}</h2>
          <p className="text-[#A0A0AB] text-base sm:text-lg max-w-3xl leading-relaxed">{t("about_text")}</p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, i) => (
            <motion.div key={feature.title} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.15 }}
              data-testid={`about-feature-${i}`} className="glass-card rounded-3xl p-8 group hover:-translate-y-2 transition-all duration-300 hover:border-[#00F0FF]/30">
              <div className="w-14 h-14 rounded-2xl bg-[#00F0FF]/10 flex items-center justify-center mb-6 group-hover:bg-[#00F0FF]/20 transition-colors">
                <feature.icon className="w-7 h-7 text-[#00F0FF]" />
              </div>
              <h3 className="font-['Unbounded'] text-xl font-semibold text-white mb-3">{feature.title}</h3>
              <p className="text-[#A0A0AB] text-base leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
